import { render, staticRenderFns } from "./ModalSalaDeEspera.vue?vue&type=template&id=34908a44&scoped=true"
import script from "./ModalSalaDeEspera.vue?vue&type=script&lang=ts"
export * from "./ModalSalaDeEspera.vue?vue&type=script&lang=ts"
import style0 from "./ModalSalaDeEspera.vue?vue&type=style&index=0&id=34908a44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34908a44",
  null
  
)

export default component.exports